const isAddonGroup = (addon, key) => {
  return addon.productTitle
    .replace(/ /g, '')
    .toUpperCase()
    .includes(key);
};

export default isAddonGroup;
